import { Link } from 'react-router-dom';

import Box from '@mui/joy/Box';
import Skeleton from '@mui/joy/Skeleton';
import ListItem from '@mui/joy/ListItem';
import ListItemButton from '@mui/joy/ListItemButton';
import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';
import Tooltip from '@mui/joy/Tooltip';
import Chip from '@mui/joy/Chip';

import useUserIdentity from 'hooks/useUserIdentity';
import IdentityAvatar from 'components/IdentityAvatar';
import { CollabTitle } from 'components/CollaboratorListItem';
import { CollabProps } from 'stores/collab_store';
import DateUI from 'components/Date';

import useClock from 'hooks/useClock';

export default function CollabListItem({ collab }: { collab: CollabProps|null }) {

    const { currentIdentity } = useUserIdentity();
    const { currentClock } = useClock();
    const clockedIn = collab?.uuid && currentClock?.associated_uuid == collab.uuid;

    const url = collab?.uuid ? ((currentIdentity.role == 'assistant') ?
        `/collab/${collab.uuid}` : `/project/${collab.project}/collab/${collab.uuid}`) : '#loading';

    return (
        <Link to={url}>
            <ListItemButton
                                                     variant={clockedIn ? 'soft' : 'plain'}
                                                     color={clockedIn ? 'primary' : 'neutral'}

                sx={{
                    padding: 0,
                    borderRadius: 'lg',
                }}
            >
                <ListItem sx={{ paddingLeft: 0, width: '100%' }} >
                    <Stack
                        sx={{ width: '100%' }}
                        margin={1}
                        spacing={1}
                    >
                        <Stack direction="row">

                            <Stack spacing={1}>
                                <CollabTitle collab={collab} />
                            </Stack>

                        </Stack>

                        <Stack
                            alignItems="center"
                            direction="row"
                            spacing={1}
                            sx={{ '--Avatar-size': '18px' }}
                        >

                            <Typography level="body-xs">

                            {(collab?.identity && (collab?.identity != currentIdentity.key)) && collab.identity &&
                                    <IdentityAvatar
                                        interactive={false}
                                        size="inline"
                                        identityKey={collab.identity} />}
                            </Typography>

                        </Stack>
                        <Stack
                            alignItems="center"
                            direction="row"
                            spacing={1}>

                            <Tooltip arrow
                                title="This is a collab.">
                                <Chip color="success" size="sm">
                                    Collab
                                </Chip>
                            </Tooltip>


                            <Box flexGrow={1} />


                            <Typography level="body-xs">
                            { collab?.date_created ? <DateUI dateString={collab.date_created} /> : <Skeleton variant="text" width={100} /> }
                            </Typography>


                        </Stack>

                    </Stack>
                </ListItem>
            </ListItemButton>
        </Link>
    );
}
